import { useEffect, useMemo } from 'react';
import { LoadingTable } from '@/components';
import { UserTabProps } from './UsersTab.types';
import { UsersTable } from '../UsersTable';
import { useGetUsersListQuery } from '@/services';
import { useSnackbar } from '@/hooks';
import { getFilteredUsers } from '../../user-management.utils';

export const UsersTab = ({
  searchQuery,
  activeTab,
  sortBy,
  sortOrder,
  isDeleting,
  usersBodyRef,
  roleLabels,
  handleEditIconClick,
  handleDeleteIconClick
}: UserTabProps) => {
  const { setSnackbarMessage } = useSnackbar();
  const { data: users = [], isFetching, isLoading: isUsersLoading, isError } = useGetUsersListQuery();

  useEffect(() => {
    if (isError) {
      setSnackbarMessage('Помилка завантаження користувачів', 'error');
    }
    // if (!err?.message?.includes('already in progress')) {
    //   showError('Помилка завантаження даних');
    // }
  }, [isError, setSnackbarMessage]);

  const FilteredUsers = useMemo(
    () => getFilteredUsers(users, searchQuery, sortOrder, sortBy),
    [users, searchQuery, sortOrder, sortBy]
  );

  if (activeTab !== 'users') return null;

  if (isUsersLoading || isFetching) {
    return <LoadingTable message="Завантаження користувачів..." rows={8} columns={8} />;
  }

  return (
    <UsersTable
      bodyRef={usersBodyRef}
      users={FilteredUsers}
      roleLabels={roleLabels}
      isLoading={isDeleting}
      onEdit={handleEditIconClick}
      onDelete={handleDeleteIconClick}
    />
  );
};
